import { Chip, Tooltip, type ChipProps } from '@mui/material'
import { LockedPadlockOMIcon } from '@omnea-app/icons'
import { type RecordConfidentiality } from './inheritedConfidentiality'
import { useInheritedConfidentialityCopy } from './useInheritedConfidentialityCopy'

type Props = {
  label: string
  tooltip: string
  size?: ChipProps['size']
}

export const ConfidentialChip = ({ label, tooltip, size = 'small' }: Props) => (
  <Tooltip title={tooltip}>
    <Chip size={size} icon={<LockedPadlockOMIcon />} label={label} />
  </Tooltip>
)

type RecordConfidentialChipProps = Pick<Props, 'size'> & {
  confidentiality: RecordConfidentiality
  /** The feature's own words for a record marked itself. */
  ownMark: Pick<Props, 'label' | 'tooltip'>
}

/** The own mark's chip, or one naming the confidential parent a record inherits from; nothing for an open record. */
export const RecordConfidentialChip = ({ confidentiality, ownMark, size }: RecordConfidentialChipProps) => {
  const inherited = useInheritedConfidentialityCopy(confidentiality.inheritedFrom)
  if (confidentiality.isConfidential) return <ConfidentialChip {...ownMark} size={size} />
  if (inherited == null) return null
  return <ConfidentialChip label={inherited.chip} tooltip={inherited.chipTooltip} size={size} />
}
